import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const WinPayTiles = ({ serviceDetails = [] }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const homeSections = useSelector(
      (state) => state.dashboard.dashboardData.HomeSections
    );
  const isWincentiveRewards = homeSections.some(item => item.ServiceId === 11);
  const handleBackClick = () => {
    navigate(-1);
  };

  const handleCardClick = (cardType) => {
    navigate('/pay-cards', { state: { cardType } });
  };

  return (
    <>
      <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn me-3" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> {t("back")}
          </span>
        </button>
      </div>

      <div className="row mt-4">
        <div className="col-md-6 col-lg-6 mt-3 mt-md-5">
          <div
            className="winpay-card-tiles"
            onClick={() => handleCardClick('benefit')}
          >
            <h2 className="winpay-card-tiles-title mb-3">
              {isHighmarkPortal ? t('viewmybenefitwincardsHighmark') : t('viewmybenefitwincards')}
            </h2>
            <p>
              {isHighmarkPortal ? t("ffbCardDescription") : t("wincardsDescription")}
            </p>
          </div>
        </div>

        {/* Conditionally render WINcentive card only if not Highmark */}
        {!isHighmarkPortal && isWincentiveRewards && (
          <div className="col-md-6 col-lg-6 ms-auto mt-3 mt-md-5">
            <div
              className="winpay-card-tiles"
              onClick={() => handleCardClick('wincentive')}
            >
              <h2 className="winpay-card-tiles-title mb-3">
                {t('viewmywincensivewincard')}
              </h2>
              <p>{t("winrewardsDescription")}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WinPayTiles;
